const zones = [
    {
        name: "America/New_York",
        label: "Eastern U.S.",
        format: "h:mm a",
    },
    {
        name: "America/Chicago",
        label: "Central U.S.",
        format: "h:mm a",
    },
    {
        name: "America/Los_Angeles",
        label: "Pacific U.S.",
        format: "h:mm a",
    },
    {
        name: "Asia/Shanghai",
        label: "China",
        format: "H:mm",
    },
    {
        name: "Asia/Kolkata",
        label: "India",
        format: "H:mm",
    },
    {
        name: "Asia/Riyadh",
        label: "Saudi Arabia",
        format: "H:mm",
    },
    {
        name: "Europe/Bucharest",
        label: "Eastern Europe",
        format: "H:mm",
    },
    {
        name: "Europe/Paris",
        label: "Central Europe",
        format: "H:mm",
    },
    {
        name: "Europe/Lisbon",
        label: "Western Europe",
        format: "H:mm",
    },
]
export default zones
